export const { ORG_NAME, SENTRY_DSN, SENTRY_ENVIRONMENT, YM_COUNTER_ID } =
  __NODE__
    ? {
        ORG_NAME: process.env.ORG_NAME,
        SENTRY_ENVIRONMENT: process.env.SENTRY_ENVIRONMENT,
        SENTRY_DSN: process.env.SENTRY_DSN,
        YM_COUNTER_ID: process.env.YM_COUNTER_ID,
      }
    : appConfig;
